import React from "react";

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { TextField, Button } from '@material-ui/core';
import { useForm, Controller } from "react-hook-form";
import submitData from '../submitData';
import { useHistory } from "react-router-dom";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useState } from 'react';


const useStyles = makeStyles((theme) => ({
    formControlLabel: {
        fontSize: 16,
        color: '#4A4A4A',
        padding: theme.spacing(0, 0, 1, 0)
    },

}));

const Allergies = ({ NextButton, handleData, data, saveChangesState, isEdit, dispatch }: any) => {
    const history = useHistory();
    const { trigger, getValues, control, setValue, errors } = useForm();
    const [allergies, setAllergies] = useState(false);
    const classes = useStyles();
    const [txtDisabled, setTxtnDisabled] = useState(true)

    const handleNext = async (data: any): Promise<void> => {
        handleData(data);
    }

    const saveChanges = async (update = false) => {
        const isValid = await trigger();
        if (isValid) {
            let dataPass = {
                patientHasNoAllegies: allergies,
                PatientHasNoAllegies: allergies,
                patientAllergies: getValues('PatientAllergies')
            }

            handleData(dataPass);
            if (update == true) submitData({ ...data, ...dataPass }, dispatch, history);
        }
    }

    React.useEffect(() => {
        setValue("PatientAllergies", data.PatientAllergies || data.patientAllergies || "");
        setAllergies(data.PatientHasNoAllegies);
    }, [data])

    React.useEffect(() => {
        saveChangesState[1](() => saveChanges);
    }, [data])

    const onNextButtonClick = async (): Promise<boolean> => {
        const isValid = await trigger();
        if (isValid) {
            let dataPass = {
                PatientHasNoAllegies: allergies,
                PatientAllergies: getValues('PatientAllergies')
            }
            await handleNext(dataPass);
        }

        return isValid;
    }
    return (
        <React.Fragment >
            <Grid container style={{paddingTop:40}} alignItems="flex-start">

                <Grid container item alignItems="flex-start">
                    <Grid item xs={6}>
                        <Typography style={{ fontSize: 36, fontWeight: 900 }}>
                            Patient Allergies</Typography>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: 'right' }}>
                        {!isEdit && <NextButton onClick={onNextButtonClick} />}
                        <Button id="update_changes" style={{ display: "none" }} onClick={() => saveChanges(true)}></Button>
                        <Button id="save_changes" style={{ display: "none" }} onClick={() => saveChanges(false)}></Button>
                    </Grid>

                    <div style={{ display: "flex", flexDirection: "column", }}>
                        <Controller
                            name='NoAllegies'
                            defaultValue=''
                            control={control}
                            render={(props) => (
                                <FormControlLabel
                                    onChange={e => {
                                        setAllergies(!allergies);
                                        setValue('NoAllegies', !allergies);
                                        props.onChange(e)
                                    }}
                                    style={{ marginTop: 30 }}
                                    checked={allergies}
                                    control={<Checkbox color="primary" />}
                                    label='Patient has no allergies' />
                            )}
                        />
                    </div>

                    <Grid alignItems="flex-start" item xs={12} style={{ paddingTop: 20 }}>

                        {
                            !allergies ?
                                <Controller
                                    name='PatientAllergies'
                                    defaultValue=''
                                    control={control}
                                    as={<TextField
                                        placeholder="Enter allergies"
                                        multiline
                                        defaultValue="Default Value"
                                        variant="outlined"
                                        error={errors.PatientAllergies}
                                        helperText={errors.PatientAllergies ? errors.PatientAllergies.message : ""}
                                        InputProps={{
                                            style: {
                                                height: 310,
                                                flexDirection: 'column'
                                            }
                                        }}
                                    />
                                    }
                                    rules={{
                                        required: "Field is required",
                                    }}
                                />
                                : null
                        }

                    </Grid>

                </Grid>
            </Grid>
        </React.Fragment >
    );
}

export default Allergies;